import { render, staticRenderFns } from "./Book.vue?vue&type=template&id=42032dd6&lang=pug"
import script from "./Book.vue?vue&type=script&lang=js"
export * from "./Book.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SurveyHideNextCompleteStyle: require('/home/docker/code/frontend/components/survey/HideNextCompleteStyle.vue').default,Spinner: require('/home/docker/code/frontend/components/Spinner.vue').default,Icon: require('/home/docker/code/frontend/components/Icon.vue').default})
